const colors = {
  primaryYankeesBlue: '#702E51',
  primaryNewCar: '#EA523B',
  primaryWhite: '#FFFFFF',
  primaryRed: '#DB0404',
  primaryDarkJungleGreen: '#11222B',
  primaryLink: '#0066FF',
  grey1: '#818387',
  grey2: '#C4C4C4',
  grey3: '#D3D7DE',
  grey4: '#ECEDED',
  grey5: '#F2F1F3',
  grey6: '#F9F9F9',
  text: {
    info: '#4D98F7',
    success: '#4ACE78',
    danger: '#F17268',
    warning: '#FCA549',
  },
  backgound: {
    info: '#D0E3FB',
    success: '#C3EFDA',
    danger: '#FBD5D2',
    warning: '#FAEDC5',
  },
  forGraphicElements: '#5183A6',
  chart: {
    downy: '#64D7A0',
    apricot: '#E87A71',
    mariner: '#2356CF',
    marigold: '#F9D872',
    carminePink: '#EA523B',
    carminePinkLight: '#F08676',
    oldMauve: '#702E51',
    blackOlive: '#404040',
    richBrilliantLavender: '#EEBDB4',
    pastelOrange: '#F9B342',
    pastelOrangeLight: '#FCC97C',
    dimGray: '#6E5F6D',
  }
};

export default colors;
